<script setup>
// NOTICE: KAPTION-INTEGRATION - Shared tabs for WhatsApp Campaigns/Templates
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';

const { t } = useI18n();
const route = useRoute();
const { isKaptionFlagEnabled } = useKaptionFeatureFlags();

const allTabs = [
  { label: 'CAMPAIGNS', routeName: 'campaigns_whatsapp_index' },
  { label: 'TEMPLATES', routeName: 'campaigns_whatsapp_templates' },
];

const tabs = computed(() =>
  allTabs.filter(tab => {
    if (tab.routeName === 'campaigns_whatsapp_templates') {
      return isKaptionFlagEnabled('KAPTION_WHATSAPP_TEMPLATE_MANAGEMENT');
    }
    return true;
  })
);

const activeRouteName = computed(() => route.name);
</script>

<template>
  <div class="flex items-center h-8 rounded-lg bg-n-alpha-1 w-fit">
    <router-link
      v-for="tab in tabs"
      :key="tab.routeName"
      :to="{ name: tab.routeName }"
      class="relative px-4 truncate py-1.5 text-sm border-0 outline-1 outline rounded-lg transition-colors duration-300 ease-in-out hover:text-n-brand"
      :class="[
        activeRouteName === tab.routeName
          ? 'text-n-blue-text bg-n-solid-active outline-n-container dark:outline-transparent'
          : 'text-n-slate-10 outline-transparent h-8',
      ]"
    >
      {{ t(`CAMPAIGN.WHATSAPP.TABS.${tab.label}`) }}
    </router-link>
  </div>
</template>
